import { render } from "./iframe.vue?vue&type=template&id=9d3cb7ca&scoped=true&ts=true"
import script from "./iframe.vue?vue&type=script&lang=ts"
export * from "./iframe.vue?vue&type=script&lang=ts"

import "./iframe.vue?vue&type=style&index=0&id=9d3cb7ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d3cb7ca"]])

export default __exports__